import { defaultReturn, generateDefaultActions, makeWritePayload } from "shared-utility/store/utils/helpers";

const initialState = {
  selectedLoansForDSCR: [],
  dscrReportComponent: null,
  dscrCalculations: null,
  totalDscrValue: null
};

export const SET_DSCR_SETUP_SELECTIONS = generateDefaultActions("SET_DSCR_SETUP_SELECTIONS");
export const setDscrSetupSelections = payload => makeWritePayload(SET_DSCR_SETUP_SELECTIONS.value, payload);

export const SET_DSCR_SETUP_TO_DEFAULT = generateDefaultActions("SET_DSCR_SETUP_TO_DEFAULT");
export const setDscrSetupToDefault = () => makeWritePayload(SET_DSCR_SETUP_TO_DEFAULT.value, initialState);

export const actionCreators = {
  setDscrSetupSelections,
  setDscrSetupToDefault
};


export const lenderReportsDscrSetupReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case SET_DSCR_SETUP_SELECTIONS.value:
      return defaultReturn({ ...state, ...payload });

    case SET_DSCR_SETUP_TO_DEFAULT.value:
      return defaultReturn({ ...payload });

    default:
      return state;
  }
};
